/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/typeahead/index.d.ts" />

export class AddressTypeAhead {
	private _url: string;
	private _displayingUnits: boolean;

	constructor(url) {
		this._url = url;
		this._displayingUnits = false;
	}

	Setup(typeaheadId: string, melissaKeyId: string, unitNumberId: string) {

		var typeaheadName = typeaheadId.split('_').join('.');
		var timeout;

		$("#loadingSpinner").hide();

		var xhr;

		$("#" + typeaheadId).on('input', function () {
			if (!$("#" + typeaheadId).val() || $("#" + typeaheadId).val()[0].length === 0) {
				clearTimeout(timeout);
				timeout = null;
				$("#loadingSpinner").hide();
				if (xhr) {
					xhr.abort();
				}
			}
		});

		var map = {};
		var objects = [];
		var bestPictures;


		$("#" + typeaheadId).typeahead({
			highlight: true,
		},
			{
				limit: 20,
				source: (query, syncResults, asyncResults) => {
					if (query.length < 3) {
						return;
					}
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}

					if (xhr) {
						xhr.abort();
					}


					timeout = setTimeout(() => {
						$("#loadingSpinner").show();

						//not sure why this is needed either since with valid input bound model this is how it's named anyways
						//Handle unique typeahead field names
						//if ($(".icf-typeahead-field").length) {
						//	$(".icf-typeahead-field:not([readonly])").attr("id", typeaheadName);
						//	$(".icf-typeahead-field:not([readonly])").attr("name", typeaheadName.split('_').join('.'));
						//}

						var datax = $("#validate-form").serialize();

						//I'm not sure why this exists
						//Reset typeahead field to be unique
						//if ($(".icf-typeahead-field").length) {
						//	var uniqueFldId = Date.now();
						//	$(".icf-typeahead-field").attr("id", uniqueFldId);
						//	$(".icf-typeahead-field").attr("name", uniqueFldId);
						//}

						//var url = '@Url.Action("_TypeaheadAddress", "Eligibility")';

						xhr = $.ajax(
							{
								type: "POST",
								url: this._url,
								data: datax,
								success: (jsonData) => {
									console.log(jsonData);
									map = {};
									objects = [];
									//capitalization matters for .address since .Address doesn't work
									$.each(jsonData, (i, object) => {
										map[object.Address] = object;
										objects.push(object.Address);
									});
									asyncResults(objects);
									$("#loadingSpinner").hide();

									clearTimeout(timeout);
									timeout = null;
									xhr = null;
								}
							});
					}, 400);
				},
				templates: {
					notFound: [
						'<div>',
						'No results found',
						'</div>'
					].join('\n')
				}
			}).keyup((e) => {
				//Ignore tab
				if (e.keyCode != 9) {
					$("#" + melissaKeyId).val("");
				}
			});;

		$("#" + typeaheadId).on('typeahead:selected', (evt, item) => {
			//Check if selected address has units.
			if (map[item].Units && map[item].Units.length > 0) {
				this._displayingUnits = true;
				$("#" + unitNumberId).empty();
				$("#" + unitNumberId).append($('<option></option>').attr('value', '').text(''));

				$.each(map[item].Units, (index, item) => {
					$("#" + unitNumberId).append($('<option></option>').attr('value', item.MelissaAddressKey).text(item.UnitName));
				});

				$('#divUnit').show();
				$("#" + melissaKeyId).val('');
				this.SetCISTypeaheadError(typeaheadName, "");

			} else {
				this._displayingUnits = false;
				$('#divUnit').hide();
				$("#" + melissaKeyId).val(map[item].Key);

				var e: Event = new Event('icf-eligibility-selected');
				document.dispatchEvent(e);
				this.SetCISTypeaheadError(typeaheadName, "");
			}
		});

		$("#" + typeaheadId).blur(() => {
			//console.log("blur melissa: " + $("#" + melissaKeyId).val());
			//console.log("blur typeaheadName: " +$("#" + typeaheadId).val());

			//if CIS is chosen instead of Melissa, it will have a -1 MAK
			var rid = $("#" + melissaKeyId).val();
			if ((rid == "" || rid == null) && (this._displayingUnits == false)) {
				this.SetCISTypeaheadError(typeaheadName, "Please select an address from the list.");
				$("#" + typeaheadId).val("");

				var e: Event = new Event('icf-eligibility-deselected');
				document.dispatchEvent(e);

			} else {
				this.SetCISTypeaheadError(typeaheadName, "");
			}

		});


		$("#" + unitNumberId).change(() => {
			$("#" + melissaKeyId).val($("#" + unitNumberId).val());

			var e: Event = new Event('icf-eligibility-selected');
			document.dispatchEvent(e);
		});

		$("#" + typeaheadId).prop('autocomplete', 'notallowed');
	}

	SetCISTypeaheadError(name, message) {
		var span = $("span[data-valmsg-for=\"" + name + "\"]");
		if (span && span.length > 0) {
			$(span).html(message);
			if (message && message != "") {
				$(span).removeClass("field-validation-valid");
				$(span).addClass("field-validation-no-valid");
			} else {
				$(span).removeClass("field-validation-no-valid");
				$(span).addClass("field-validation-valid");
			}
		}
	}
}


